import axios from "services/axios";
import {useMutation, useQueryClient} from "react-query";

import {QUERY} from "./useQueryAppoitment";

export function useCancelAppoitment(id) {
	const queryClient = useQueryClient();

	return useMutation(values => axios.post(`/booking/${id}/cancel`, values).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries(QUERY);
			queryClient.removeQueries(QUERY);
		},
	});
}

export function usePaidAppoitment(id) {
	const queryClient = useQueryClient();

	return useMutation(values => axios.post(`/booking/${id}/paid`, values).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries(QUERY);
			queryClient.removeQueries(QUERY);
		},
	});
}

export function useSharePaymentLinkAppoitment(id) {
	const queryClient = useQueryClient();

	return useMutation(values => axios.post(`/booking/${id}/send-payment-link`, values).then(res => res.data), {
		onSuccess: () => {
			queryClient.invalidateQueries(QUERY);
			queryClient.removeQueries(QUERY);
		},
	});
}
